package com.example.mystybag.cropImage.logic

import com.example.mystybag.core.logic.base.NavigatorConfig
import com.example.mystybag.sharedmodels.SCImage

data class NavigatorProfileCropImage(
    val selectedImage: SCImage,
    val callbacks: ProfileImageCropperCallbacks,
    val aspectRatio: Float? = null, // null = square (1:1), otherwise width/height ratio (e.g., 9f/16f portrait, 16f/9f landscape)
    /** When set, the cropped bitmap is scaled to this pixel size (same aspect as [aspectRatio]). */
    val outputWidth: Int? = null,
    val outputHeight: Int? = null,
): NavigatorConfig()

data class NavigatorCropImage(val selectedImage: SCImage, val cardPlasticType: Int = 0, val onImageCropped: (String, String, String) -> Unit): NavigatorConfig()